var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoExit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 50 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-exit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-exit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "exit",
    transform: "translate(5.000000, 13.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.577,20.1 L28.912,9.434 C27.719,8.241 25.785,8.241 24.592,9.434 C23.399,10.627 23.399,12.562 24.592,13.755 L30.071,19.234 L13.541,19.234 C11.854,19.234 10.486,20.602 10.486,22.29 C10.486,23.978 11.854,25.345 13.541,25.345 L30.07,25.345 L24.591,30.824 C23.398,32.017 23.398,33.951 24.591,35.146 C25.188,35.742 25.969,36.041 26.751,36.041 C27.532,36.041 28.315,35.742 28.911,35.146 L39.576,24.48 C40.18,23.875 40.477,23.081 40.4701985,22.29 C40.479,21.498 40.182,20.704 39.577,20.1 Z",
    id: "Path",
    fill: "#64BED2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.327,36.559 C29.856,37.031 29.307,37.395 28.711,37.646 L28.711,38.409 L6.111,38.409 L6.111,6.112 L28.711,6.112 L28.711,6.934 C29.307,7.185 29.856,7.549 30.326,8.02 L34.822,12.516 L34.822,3.055 C34.822,1.368 33.454,-1.42108547e-14 31.765,-1.42108547e-14 L3.056,-1.42108547e-14 C1.368,-1.42108547e-14 5.68434189e-14,1.368 5.68434189e-14,3.055 L5.68434189e-14,41.464 C5.68434189e-14,43.152 1.368,44.521 3.056,44.521 L31.765,44.521 C33.453,44.521 34.822,43.152 34.822,41.464 L34.822,32.064 L30.327,36.559 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    fill: "#193774"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.398000, 54.389000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#193B70",
    points: "6.549 6.469 2.498 6.469 2.498 9.211 7.251 9.211 7.251 10.904 0.388 10.904 0.388 0.668 7.236 0.668 7.236 2.377 2.497 2.377 2.497 4.816 6.548 4.816 6.548 6.469"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#193B70",
    points: "12.152 4.2 14.072 0.669 16.498 0.669 13.516 5.745 16.576 10.905 14.121 10.905 12.151 7.321 10.183 10.905 7.73 10.905 10.789 5.745 7.808 0.669 10.234 0.669"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#193B70",
    points: "19.88 10.905 17.772 10.905 17.772 0.668 19.88 0.668"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#193B70",
    points: "29.338 2.377 26.202 2.377 26.202 10.904 24.093 10.904 24.093 2.377 21 2.377 21 0.668 29.339 0.668 29.339 2.377"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.699,9.909 C28.699,9.585 28.806,9.321 29.025,9.122 C29.244,8.921 29.515,8.817 29.843,8.817 C30.178,8.817 30.452,8.921 30.67,9.122 C30.888,9.321 30.997,9.585 30.997,9.909 C30.997,10.227 30.89,10.485 30.673,10.684 C30.458,10.883 30.181,10.983 29.843,10.983 C29.512,10.983 29.237,10.883 29.022,10.684 C28.806,10.485 28.699,10.227 28.699,9.909 Z",
    id: "Path",
    fill: "#64BED2"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoExit);
export default __webpack_public_path__ + "static/media/logo-exit.20990a53a1da76d29abaa810604835c1.svg";
export { ForwardRef as ReactComponent };